import React from 'react';

import GoogleViewCartReporter from "./GoogleViewCartReporter";
import AdobeViewCartReporter from "./AdobeViewCartReporter";
import KlaviyoViewCartReporter from "./KlaviyoViewCartReporter";
import CatchErrors from "../../../Utility/CatchErrors";
// import AdobeViewCartReporter from "./AdobeViewCartReporter";
// import {isNola} from "../../../lib/EmbeddedConfig";

// 2023-05 Report only to Google; Facebook lacks a View Cart reporting need
export default function ViewCartReporter({shoppingCart}) {
  return (
    <div>
      <CatchErrors><KlaviyoViewCartReporter shoppingCart={shoppingCart}  /></CatchErrors>
      <CatchErrors><GoogleViewCartReporter shoppingCart={shoppingCart}  /></CatchErrors>
      <CatchErrors><AdobeViewCartReporter shoppingCart={shoppingCart} /></CatchErrors>
    </div>
  );
}

// ViewCartReporter.propTypes = { }

